import React from 'react';
import Select from 'react-select';

const Options = ({
  options,
  label,
  required,
  errors,
  placeholder,
  onSelected,
  initialValue,
  isMulti,
  disabled,
  keys,
}) => {
  const [value, setValue] = React.useState(null);

  const handleInputChange = (newValue) => {
    setValue(newValue);
    if (isMulti) {
      onSelected({ ...value, ...(newValue || null) });
    } else {
      onSelected(newValue?.value || null);
    }
  };

  React.useEffect(() => {
    setValue(initialValue);
  }, [keys]);

  return (
    <>
      {label ? (
        <label className={required ? 'form-label required' : 'form-label'}>
          {label}
        </label>
      ) : null}
      <Select
        classNamePrefix={errors ? 'is-invalid' : 'select'}
        placeholder={placeholder}
        options={options}
        value={value}
        onChange={handleInputChange}
        defaultOptions
        isClearable
        isSearchable
        className="bg-white"
        isMulti={isMulti}
        isDisabled={disabled}
        key={keys}
      />
      {errors ? <div className="invalid-feedback d-block">{errors}</div> : null}
    </>
  );
};

export default Options;
